// Framework
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
// Components
import { PrivacyPolicyComponent } from "./components/privacy-policy/privacy-policy.component";

const routes: Routes = [
    {
        path: "",
        component: PrivacyPolicyComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PrivacyPolicyRoutingModule { }
